// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"197":"e7e7cb5c85e51ce0","815":"5b5c5f91450b2530","888":"112495035b880485"}[chunkId] + ".css";
};